export const showLeftPaneButton = "IAYH3";
export const hideLeftPaneButton = "FMLcIe";
export default {showLeftPaneButton,hideLeftPaneButton};